import { User, UserRole } from "types/user";
import { Permissions, PermissionAction, PermissionSubject } from "types/permissions";

const AdminPermissions: Permissions = {
  dashboard: ["all"],
  storages: ["all"],
  clients: ["all"],
  orders: ["all"],
  invoices: ["all"],
  services: ["all"],
  members: ["all"],
  settings: ["all"],
  "driver-licenses": ["all"],
  "car-rental-costs": ["all"],
  "support-tickets": ["all"],
  "ev-chargers": ["all"],
  "heat-pumps": ["all"],
  cameras: ["all"],
  anomalies: ["all"],
  "support-ticket-types": ["all"],
  "client-records": ["all"],
  "contract-records": ["all"],
  "user-role": ["all"],
};

const EditorPermissions: Permissions = {
  dashboard: [],
  storages: ["read"],
  clients: ["read"],
  orders: ["read"],
  invoices: [],
  services: ["read"],
  members: [],
  settings: ["read"],
  "driver-licenses": ["read"],
  "car-rental-costs": [],
  "support-tickets": ["read"],
  "ev-chargers": ["read"],
  "heat-pumps": ["read"],
  cameras: ["read"],
  anomalies: ["read"],
  "support-ticket-types": ["read"],
  "client-records": ["read"],
  "contract-records": ["read"],
  "user-role": ["read"],
};

const permissions = {
  [UserRole.Admin]: AdminPermissions,
  [UserRole.Editor]: EditorPermissions,
} as const;

export const canRole = (role: UserRole, action: PermissionAction, subject: PermissionSubject) => {
  return permissions[role][subject].includes(action) || permissions[role][subject].includes("all");
};

export const canUser = (user: User | undefined, action: PermissionAction, subject: PermissionSubject) => {
  return !user ? false : canRole(user.role, action, subject);
};
